<template>
	<v-card class="rounded-b-xl">
		<v-data-table
			:headers="headers"
			:items="itens"
			:search="search"
			:loading="loading"
			:options.sync="options"
			:server-items-length="total"
			fixed-header
			class="elevation-9 mb-4"
			:footer-props="{
				'items-per-page-text': 'itens por página',
				'items-per-page-all-text': 'TODOS',
			}"
			@click:row="editar"
		>
			<template v-slot:no-data>
				<v-alert :value="true"> Nenhum item foi lançado </v-alert>
			</template>
			<template v-for="(slot, name) in $scopedSlots" v-slot:[name]="item">
				<slot :name="name" v-bind="item"></slot>
			</template>
			<template v-slot:[`footer.page-text`]="items">
				{{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
			</template>
			<slot></slot>
		</v-data-table>
	</v-card>
</template>


<script>
export default {
	props: ['search', 'headers', 'itens', 'loading', 'total'],
	data() {
        return {
            options: {}
        }
	},
	methods:{
		editar(item){
			this.$emit('editar', item.id)
		}
	},
	watch: {
		options: {
			handler() {
				this.$emit('setOptions', this.options)
			},
			deep: true,
		},
	}
}
</script>